import { render, staticRenderFns } from "./Nav2.vue?vue&type=template&id=a089f66c&scoped=true"
import script from "./Nav2.vue?vue&type=script&lang=js"
export * from "./Nav2.vue?vue&type=script&lang=js"
import style0 from "./Nav2.vue?vue&type=style&index=0&id=a089f66c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a089f66c",
  null
  
)

export default component.exports